var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justify-content-center py-1",class:`sumo-bg-${_vm.bannerDetails.bg_color}`},[_c('DealBannerContent',{attrs:{"banner-details":_vm.bannerDetails,"display-timer":_vm.displayTimer,"sticky-timer":_vm.mobileStickyTimer || _vm.desktopStickyTimer,"tooltip-id":"mobile-deal-banner-tooltip"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }